import { render, staticRenderFns } from "./PolicyDocumentCreate.vue?vue&type=template&id=6172c99c&"
import script from "./PolicyDocumentCreate.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports